import { put, call, takeEvery, takeLatest, delay } from 'redux-saga/effects';
import ActionTypes from '../constants/ActionTypes';
import { getJupyterPodStatus, createJupyterPod } from '../api/test';

import { errorLogger } from '../utils/trackingUtil';
import { getSolutionSet } from '../actions/test';
import { showErrorToast } from '../actions/toast';
import {
  DJP_POD_HEALTH_CONTACT_SUPPORT_MESSAGE,
  DJP_HEALTH_CHECK_INTERVAL_MS,
  DJP_HEALTH_CHECK_MAX_ATTEMPTS,
} from '../constants/Constants';

function* getJupyterResourceStatus(args) {
  try {
    const url = `/get_servers/djp/${args.testSolutionId}`;
    const resp = yield call(getJupyterPodStatus, url);
    yield put({
      type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
      payload: resp.data,
    });
  } catch (err) {
    errorLogger(err);
  }
}

function* checkAndCreateJupyterResource(args) {
  try {
    const url = `/create_servers/djp/${args.testSolutionId}`;
    yield call(createJupyterPod, url, false);

    yield put({
      type: ActionTypes.IS_POD_BASED_PROBLEM,
      payload: true,
    });
    yield put({
      type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
      payload: { isReady: false },
    });
  } catch (err) {
    if (
      err.response.status === 400 &&
      err.response.message === 'Test does not have any DJP questions'
    )
      yield put({
        type: ActionTypes.IS_POD_BASED_PROBLEM,
        payload: false,
      });
    else {
      yield put({
        type: `${ActionTypes.CHECK_ENV_SETUP_STATUS}_SUCCESS`,
        payload: { isReady: null },
      });
    }
  }
}

function* waitUntilDJPReady(action) {
  const { assessmentId, problemSlug, testId } = action.payload;
  for (let i = 0; i < DJP_HEALTH_CHECK_MAX_ATTEMPTS; i += 1) {
    try {
      const url = `/get_servers/djp/${assessmentId}`;
      const resp = yield call(getJupyterPodStatus, url);
      if (resp.data.is_ready) {
        yield put(getSolutionSet(testId, true));
        yield put({
          type: ActionTypes.DJP_POD_HEALTH_STATE_UPDATE,
          payload: { problemSlug, isReady: true },
        });
        return;
      }
    } catch (err) {
      // Count network/backend errors as a failed attempt and keep polling.
      errorLogger(err);
    }
    yield delay(DJP_HEALTH_CHECK_INTERVAL_MS);
  }
  yield put(showErrorToast(DJP_POD_HEALTH_CONTACT_SUPPORT_MESSAGE));
  yield put({
    type: ActionTypes.DJP_POD_HEALTH_STATE_UPDATE,
    payload: { problemSlug, isReady: false },
  });
}

function* djpPodRestartAndHealthCheck(action) {
  const { problemSlug, assessmentId, testId, recreate } = action.payload;
  if (!assessmentId || !problemSlug || !testId) return;

  try {
    try {
      yield call(
        createJupyterPod,
        `/create_servers/djp/${assessmentId}`,
        recreate
      );
      yield put({
        type: ActionTypes.DJP_POD_HEALTH_STATE_UPDATE,
        payload: { problemSlug, isReady: false },
      });
    } catch (err) {
      errorLogger(err);
    }

    yield call(waitUntilDJPReady, {
      payload: { assessmentId, problemSlug, testId },
    });
  } catch (e) {
    errorLogger(e);
  }
}

export default function* datascienceJupyterSaga() {
  yield takeEvery(ActionTypes.CHECK_ENV_SETUP_STATUS, getJupyterResourceStatus);
  yield takeEvery(
    ActionTypes.CHECK_DJP_PROBLEM_IN_TEST_AND_SETUP,
    checkAndCreateJupyterResource
  );
  yield takeLatest(ActionTypes.DJP_POD_RESTART, djpPodRestartAndHealthCheck);
}
